import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: '100%',
            maxWidth: remCalc(1440),
            margin: '0 auto',
            height: 'auto',
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: ['small.base', 'small.sm', 'small-1.md', 'small-1.lg'],
            paddingX: ['xsmall.base', 'xsmall.sm', 'medium.md', 'medium.lg'],
            paddingY: ['small-1.base', 'small-1.sm', 'medium.md', 'medium.lg'],
        },
        header: {flexDirection: 'column', gap: 0, alignItems: 'flex-start'},
        heading: {
            textStyle: 'head-large',
            fontWeight: 'light',
            color: 'foreground.neutral.default',
            fontFamily: 'heading',
        },
        bodyCopy: {
            textStyle: 'head-large',
            fontWeight: 'light',
            color: 'foreground.neutral.subtle',
            fontFamily: 'heading',
            sx: {'& p': {margin: 0}},
        },
        tabList: {
            alignSelf: 'flex-start',
            display: 'flex',
            justifyContent: 'flex-start',
            gap: 0,
            padding: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
            bg: 'background.base.under',
            borderRadius: 'full',
            summaryItem: {alignItems: 'center', gap: 'xxxsmall.base', minWidth: 0},
        },
        tab: {
            minH: remCalc(36),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 'xxxsmall-1.base',
            px: 'xsmall-1.base',
            py: 'xxxsmall.base',
            borderRadius: 'full',
            color: 'foreground.neutral.default',
            textStyle: 'body-small',
            fontWeight: 'medium',
            whiteSpace: 'normal',
            overflowWrap: 'anywhere',
        },
        tabActive: {
            bg: 'background.strong.default',
            color: 'foreground.neutral.inverse',
        },
        tabIcon: {boxSize: remCalc(14), flexShrink: 0},
        grid: {
            gap: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
            rowGap: {base: 'xxsmall.base', sm: 'xxsmall.sm', md: remCalc(44)},
            alignItems: 'stretch',
            justifyContent: 'flex-start',
            width: '100%',
            minWidth: 0,
            height: 'auto',
            pt: {base: 0, md: remCalc(28)},
        },
        card: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            minWidth: 0,
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'transparent',
            boxShadow:
                '0 0 0 1px var(--border-neutral-highlight, #FFF) inset, 0 1px 2px 0 var(--neutral-xs, rgba(19, 24, 58, 0.08)), 0 0 0 1px var(--neutral-xs, rgba(19, 24, 58, 0.08))',
            borderRadius: 'large-1',
            bg: 'background.base.default',
        },
        cardHighlighted: {
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'background.strong.default',
            bg: 'background.strong.default',
            boxShadow: 'none',
            mt: {base: 0, md: remCalc(-28)},
            pt: remCalc(28),
            overflow: 'hidden',
        },
        ribbon: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: remCalc(28),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            bg: 'background.strong.default',
            color: 'foreground.neutral.inverse',
            textStyle: 'body-xsmall',
            fontWeight: 'medium',
            py: 0,
            px: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            textAlign: 'center',
        },
        media: {width: '100%', aspectRatio: '1/1', overflow: 'hidden', borderTopRadius: 'large-1'},
        content: {
            flex: 1,
            bg: 'background.base.default',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: ['xsmall-1.base', 'xsmall-1.sm', 'xsmall-1.md', 'xsmall-1.lg'],
            padding: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            minWidth: 0,
            borderBottomRadius: 'large-1',
        },
        nameAndPriceContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
        },
        title: {
            textStyle: 'body-xxlarge',
            fontWeight: 'medium',
            overflowWrap: 'anywhere',
            color: 'foreground.neutral.default',
            fontFamily: 'heading',
        },
        priceRow: {
            alignItems: 'baseline',
            flexWrap: 'wrap',
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
        },
        price: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        timing: {
            color: 'foreground.neutral.subtle',
            fontWeight: 'normal',
            textStyle: 'body-small',
        },
        summaryList: {
            flexDirection: 'column',
            listStyleType: 'none',
            padding: 0,
            margin: 0,
        },
        summaryItem: {
            alignItems: 'center',
            gap: {
                base: 'xxsmall.base',
                sm: 'xxsmall.base',
                md: 'xxsmall.lg',
                lg: 'xxsmall.lg',
            },
            py: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
            minWidth: 0,
        },
        summaryIcon: {
            boxSize: remCalc(14),
            flexShrink: 0,
            alignSelf: 'center',
        },
        summaryText: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            overflowWrap: 'anywhere',
        },
        keyFeatures: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
            listStyleType: 'none',
            padding: 0,
            margin: 0,
            textStyle: 'body-xsmall',
            color: 'foreground.neutral.default',
        },
        keyFeature: {
            alignItems: 'center',
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
            minWidth: 'max-content',
            flexShrink: 0,
            whiteSpace: 'nowrap',
            overflowWrap: 'normal',
        },
        keyFeatureIcon: {boxSize: remCalc(14), flexShrink: 0, alignSelf: 'center'},
        details: {display: 'inline', whiteSpace: 'nowrap', textStyle: 'body-xsmall'},
        cta: {
            width: '100%',
            height: 'auto',
            minH: remCalc(40),
            mt: 'auto',
            whiteSpace: 'normal',
            overflowWrap: 'anywhere',
        },
    },
}
